import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrangeForward = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M4.986 4.927a.5.5 0 0 0 .716.697L7.5 3.777v6.412a.5.5 0 1 0 1 0V3.777l1.798 1.847a.5.5 0 1 0 .716-.697l-2.656-2.73a.5.5 0 0 0-.716 0l-2.656 2.73ZM2.119 9.295l4.243-2.122v1.118L2.567 10.19l5.21 2.605a.5.5 0 0 0 .447 0l5.21-2.605-3.796-1.898V7.173l4.242 2.122a1 1 0 0 1 0 1.789l-5.21 2.604a1.5 1.5 0 0 1-1.34 0l-5.21-2.604a1 1 0 0 1 0-1.79Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default ArrangeForward
